import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "diagram-viewer-container"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pan_zoom_viewer = _resolveComponent("pan-zoom-viewer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.diagramSVG ? (_openBlock(), _createBlock(_component_pan_zoom_viewer, {
    key: 0
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.diagramSVG
    }, null, 8, _hoisted_2)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}